import React from "react";
import {Header} from "./Header";
import {BottomNav} from "./BottomNav";
import {Footer} from "./Footer";
import {ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({children}) => {
  return (
    <div>
      <Header />
      {/* Extra bottom padding on mobile so BottomNav doesn't cover content */}
      <div className="max-[768px]:pb-[60px]">
        {children}
        <Footer />
      </div>
      <BottomNav />
      <ToastContainer
        position="bottom-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
};

export default Layout;
